import qz from "qz-tray";

export const printLabelReceipt = async (printerName, selectedRowsData) => {
    if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
    }

    const config = qz.configs.create(printerName, {
        encoding: "UTF-8"
    });

    const data = buildLabel(selectedRowsData);

    await qz.print(config, data);
};

const buildLabel = (orders) => {

    const ESC = "\x1B";
    const GS = "\x1D";

    const MAX_LINES_4CM = 8; // adjust depending on printer font size

    let receipt = "";

    if (!orders || orders.length === 0) return [];

    const customer = orders[0].CustomerName.trim();

    let lines = [];

    // Header
    lines.push(customer);
    lines.push("-".repeat(48));

    // Items
    // Group by ArrivedListName
    const grouped = {};

    orders.forEach(order => {
        const key = order.ArrivedListName
            ? formatCargoCode(order.ArrivedListName)
            : "*";

        if (!grouped[key]) {
            grouped[key] = [];
        }

        grouped[key].push(order);
    });

    // Print groups
    Object.entries(grouped).forEach(([group, items]) => {

        items.forEach((order, index) => {

            const qty = `${order.ItemQty}x`;

            // First item shows AC45 -
            // Next items show only -
            const prefix =
                index === 0
                    ? `${group} - `
                    : "     - ";

            const wrapped = wrapText(order.ItemName, 30);

            wrapped.forEach((line, i) => {

                if (i === 0) {
                    lines.push(prefix + line);
                } else {
                    lines.push(" ".repeat(prefix.length) + line);
                }

            });

            // Put quantity on last wrapped line
            lines[lines.length - 1] += ` ${qty}`;
        });

        // Blank line between groups
        lines.push("");
    });



    // 📏 Calculate dynamic height
    const totalLines = lines.length;

    receipt += ESC + "@"; // init
    receipt += ESC + "a" + "\x00"; // left align

    lines.forEach(line => {
        receipt += line + "\n";
    });

    // 🔥 If less than 4cm → force height padding
    if (totalLines < MAX_LINES_4CM) {
        const diff = MAX_LINES_4CM - totalLines;

        for (let i = 0; i < diff; i++) {
            receipt += "\n";
        }
    }

    // 🔥 IMPORTANT: bottom spacing (THIS is what you asked)
    receipt += ESC + "d" + "\x06"; // feed 6 blank lines

    // Cut paper
    receipt += GS + "V" + "\x41" + "\x10";

    return [{
        type: "raw",
        format: "command",
        data: receipt
    }];
};

const formatCargoCode = (listName) => {
    if (!listName) return "*";

    const value = listName.trim().toUpperCase();

    // AIR CARGO 45 → AC45
    const airMatch = value.match(/^AIR\s+CARGO\s+(\d+)$/i);
    if (airMatch) {
        return `AC${airMatch[1]}`;
    }

    // SEA CARGO 12 → SC12
    const seaMatch = value.match(/^SEA\s+CARGO\s+(\d+)$/i);
    if (seaMatch) {
        return `SC${seaMatch[1]}`;
    }

    // If already AC45 / SC12, keep it
    if (/^(AC|SC)\d+$/i.test(value)) {
        return value;
    }

    // Otherwise return original value
    return value;
};

const wrapText = (text, maxChars = 30) => {
    const words = text.split(" ");
    const result = [];
    let line = "";

    words.forEach(word => {
        if ((line + word).length > maxChars) {
            result.push(line.trim());
            line = word + " ";
        } else {
            line += word + " ";
        }
    });

    if (line.trim()) {
        result.push(line.trim());
    }

    return result;
};